export const positions = [
  { name: "GK" },
  { name: "RB" },
  { name: "LB" },
  { name: "CB" },
  { name: "RWB" },
  { name: "LWB" },
  { name: "CDM" },
  { name: "RM" },
  { name: "LM" },
  { name: "CM" },
  { name: "CAM" },
  { name: "RW" },
  { name: "LW" },
  { name: "CF" },
  { name: "ST" },
];

export const scarcity = [
  { name: "Common", overallMin: 1, overallMax: 54, color: "#9f9f9f" },
  { name: "Limited", overallMin: 55, overallMax: 64, color: "#FFCC00" },
  { name: "Uncommon", overallMin: 65, overallMax: 74, color: "#3af24b" },
  { name: "Rare", overallMin: 75, overallMax: 84, color: "#169fed" },
  { name: "Legendary", overallMin: 85, overallMax: 94, color: "#fa53ff" },
  { name: "Ultimate", overallMin: 95, overallMax: 99, color: "#FFFFFF" },
];

export const positionAttributes = {
  ST: {
    passing: 0.1,
    shooting: 0.46,
    defense: 0.0,
    dribbling: 0.29,
    pace: 0.1,
    physical: 0.05,
    goalkeeping: 0.0,
  },
  CF: {
    passing: 0.24,
    shooting: 0.23,
    defense: 0.0,
    dribbling: 0.4,
    pace: 0.13,
    physical: 0.0,
    goalkeeping: 0.0,
  },
  LW: {
    passing: 0.24,
    shooting: 0.23,
    defense: 0.0,
    dribbling: 0.4,
    pace: 0.13,
    physical: 0.0,
    goalkeeping: 0.0,
  },
  RW: {
    passing: 0.24,
    shooting: 0.23,
    defense: 0.0,
    dribbling: 0.4,
    pace: 0.13,
    physical: 0.0,
    goalkeeping: 0.0,
  },
  CAM: {
    passing: 0.34,
    shooting: 0.21,
    defense: 0.0,
    dribbling: 0.38,
    pace: 0.07,
    physical: 0.0,
    goalkeeping: 0.0,
  },
  CM: {
    passing: 0.43,
    shooting: 0.12,
    defense: 0.1,
    dribbling: 0.29,
    pace: 0.0,
    physical: 0.06,
    goalkeeping: 0.0,
  },
  LM: {
    passing: 0.43,
    shooting: 0.12,
    defense: 0.1,
    dribbling: 0.29,
    pace: 0.0,
    physical: 0.06,
    goalkeeping: 0.0,
  },
  RM: {
    passing: 0.43,
    shooting: 0.12,
    defense: 0.1,
    dribbling: 0.29,
    pace: 0.0,
    physical: 0.06,
    goalkeeping: 0.0,
  },
  CDM: {
    passing: 0.28,
    shooting: 0.0,
    defense: 0.4,
    dribbling: 0.17,
    pace: 0.0,
    physical: 0.15,
    goalkeeping: 0.0,
  },
  LWB: {
    passing: 0.19,
    shooting: 0.0,
    defense: 0.44,
    dribbling: 0.17,
    pace: 0.1,
    physical: 0.1,
    goalkeeping: 0.0,
  },
  RWB: {
    passing: 0.19,
    shooting: 0.0,
    defense: 0.44,
    dribbling: 0.17,
    pace: 0.1,
    physical: 0.1,
    goalkeeping: 0.0,
  },
  LB: {
    passing: 0.19,
    shooting: 0.0,
    defense: 0.44,
    dribbling: 0.17,
    pace: 0.1,
    physical: 0.1,
    goalkeeping: 0.0,
  },
  RB: {
    passing: 0.19,
    shooting: 0.0,
    defense: 0.44,
    dribbling: 0.17,
    pace: 0.1,
    physical: 0.1,
    goalkeeping: 0.0,
  },
  CB: {
    passing: 0.05,
    shooting: 0.0,
    defense: 0.64,
    dribbling: 0.09,
    pace: 0.02,
    physical: 0.2,
    goalkeeping: 0.0,
  },
  GK: {
    passing: 0.0,
    shooting: 0.0,
    defense: 0.0,
    dribbling: 0.0,
    pace: 0.0,
    physical: 0.0,
    goalkeeping: 1.0,
  },
};

export const familiarity = {
  GK: {
    GK: 1,
    CB: 4,
    RB: 4,
    LB: 4,
    RWB: 4,
    LWB: 4,
    CDM: 4,
    CM: 4,
    CAM: 4,
    RM: 4,
    LM: 4,
    RW: 4,
    LW: 4,
    CF: 4,
    ST: 4,
  },
  CB: {
    GK: 4,
    CB: 1,
    RB: 3,
    LB: 3,
    RWB: 4,
    LWB: 4,
    CDM: 3,
    CM: 4,
    CAM: 4,
    RM: 4,
    LM: 4,
    RW: 4,
    LW: 4,
    CF: 4,
    ST: 4,
  },
  RB: {
    GK: 4,
    CB: 3,
    RB: 1,
    LB: 3,
    RWB: 2,
    LWB: 4,
    CDM: 4,
    CM: 4,
    CAM: 4,
    RM: 3,
    LM: 4,
    RW: 4,
    LW: 4,
    CF: 4,
    ST: 4,
  },
  LB: {
    GK: 4,
    CB: 3,
    RB: 3,
    LB: 1,
    RWB: 4,
    LWB: 2,
    CDM: 4,
    CM: 4,
    CAM: 4,
    RM: 4,
    LM: 3,
    RW: 4,
    LW: 4,
    CF: 4,
    ST: 4,
  },
  RWB: {
    GK: 4,
    CB: 4,
    RB: 2,
    LB: 4,
    RWB: 1,
    LWB: 3,
    CDM: 4,
    CM: 4,
    CAM: 4,
    RM: 3,
    LM: 4,
    RW: 3,
    LW: 4,
    CF: 4,
    ST: 4,
  },
  LWB: {
    GK: 4,
    CB: 4,
    RB: 4,
    LB: 2,
    RWB: 3,
    LWB: 1,
    CDM: 4,
    CM: 4,
    CAM: 4,
    RM: 4,
    LM: 3,
    RW: 4,
    LW: 3,
    CF: 4,
    ST: 4,
  },
  CDM: {
    GK: 4,
    CB: 3,
    RB: 4,
    LB: 4,
    RWB: 4,
    LWB: 4,
    CDM: 1,
    CM: 2,
    CAM: 3,
    RM: 4,
    LM: 4,
    RW: 4,
    LW: 4,
    CF: 4,
    ST: 4,
  },
  CM: {
    GK: 4,
    CB: 4,
    RB: 4,
    LB: 4,
    RWB: 4,
    LWB: 4,
    CDM: 2,
    CM: 1,
    CAM: 2,
    RM: 3,
    LM: 3,
    RW: 4,
    LW: 4,
    CF: 4,
    ST: 4,
  },
  CAM: {
    GK: 4,
    CB: 4,
    RB: 4,
    LB: 4,
    RWB: 4,
    LWB: 4,
    CDM: 3,
    CM: 2,
    CAM: 1,
    RM: 4,
    LM: 4,
    RW: 4,
    LW: 4,
    CF: 2,
    ST: 4,
  },
  RM: {
    GK: 4,
    CB: 4,
    RB: 3,
    LB: 4,
    RWB: 3,
    LWB: 4,
    CDM: 4,
    CM: 3,
    CAM: 4,
    RM: 1,
    LM: 3,
    RW: 2,
    LW: 4,
    CF: 4,
    ST: 4,
  },
  LM: {
    GK: 4,
    CB: 4,
    RB: 4,
    LB: 3,
    RWB: 4,
    LWB: 3,
    CDM: 4,
    CM: 3,
    CAM: 4,
    RM: 3,
    LM: 1,
    RW: 4,
    LW: 2,
    CF: 4,
    ST: 4,
  },
  RW: {
    GK: 4,
    CB: 4,
    RB: 4,
    LB: 4,
    RWB: 3,
    LWB: 4,
    CDM: 4,
    CM: 4,
    CAM: 4,
    RM: 2,
    LM: 4,
    RW: 1,
    LW: 3,
    CF: 4,
    ST: 4,
  },
  LW: {
    GK: 4,
    CB: 4,
    RB: 4,
    LB: 4,
    RWB: 4,
    LWB: 3,
    CDM: 4,
    CM: 4,
    CAM: 4,
    RM: 4,
    LM: 2,
    RW: 3,
    LW: 1,
    CF: 4,
    ST: 4,
  },
  CF: {
    GK: 4,
    CB: 4,
    RB: 4,
    LB: 4,
    RWB: 4,
    LWB: 4,
    CDM: 4,
    CM: 4,
    CAM: 2,
    RM: 4,
    LM: 4,
    RW: 4,
    LW: 4,
    CF: 1,
    ST: 2,
  },
  ST: {
    GK: 4,
    CB: 4,
    RB: 4,
    LB: 4,
    RWB: 4,
    LWB: 4,
    CDM: 4,
    CM: 4,
    CAM: 4,
    RM: 4,
    LM: 4,
    RW: 4,
    LW: 4,
    CF: 2,
    ST: 1,
  },
};

export const getOverallColor = (overall) => {
  for (let i = 0; i < scarcity.length; i++) {
    if (overall <= scarcity[i].overallMax) {
      return scarcity[i].color;
    }
  }

  return "black";
};

export const getOverallTag = (overall) => {
  return <span style={{ color: getOverallColor(overall) }}>{overall}</span>;
};

export const getCalculatedOverall = (player, position) => {
  let overall = 0;

  Object.keys(positionAttributes[position]).map((a) => {
    overall += positionAttributes[position][a] * player[a];
  });

  overall = Math.round(overall);

  if (player.positions.indexOf(position) !== 0) {
    if (player.positions.indexOf(position) > 0) {
      overall += -1;
    } else {
      let f = familiarity[player.positions[0]][position];

      if (f === 2) {
        overall += -5;
      } else if (f === 3) {
        overall += -8;
      } else {
        overall += -20;
      }
    }
  }

  return Math.max(overall, 0);
};

const getOVRsOfPlayer = (player) => {
  return positions
    .map((pos) => {
      const calcOVR = getCalculatedOverall(player, pos.name);
      return {
        pos: pos.name,
        ovr: calcOVR,
        diff: calcOVR - player.overall,
      };
    })
    .filter((a) => a.ovr > 0)
    .sort((a, b) => b.ovr - a.ovr)
    .slice(0, 3);
};

export function analyzePlayerAttributes(player) {
  const { positions, overall: OVR, height } = player;
  const primaryPos = positions[0];
  const posWeights = positionAttributes[primaryPos] || {};

  const attributes = ["pace", "shooting", "passing", "dribbling", "defense", "physical"];
  const result = [];

  // --- Regular attributes ---
  attributes.forEach((attr) => {
    const weight = posWeights[attr] || 0;
    const value = player[attr];

    if (weight > 0 || value === null || value === undefined || primaryPos === "GK") return;

    let rate = "";
    let description = attr.substring(0, 3).toUpperCase();

    if (value < 20 || value < OVR / 2) rate = "---";
    else if (value < 30 || value < OVR / 1.8) rate = "--";
    else if (value < 40 || value < OVR / 1.6) rate = "-";
    else if (value > 90 || value > OVR * 1.4) rate = "+++";
    else if (value > 80 || value > OVR * 1.2) rate = "++";
    else if (value > 70 || value > OVR) rate = "+";
    else return;

    result.push({ rate, description });
  });

  // --- Height evaluation ---
  if (height) {
    let heightRate = "";
    if (height < 165) heightRate = "---";
    else if (height < 170) heightRate = "--";
    else if (height < 175) heightRate = "-";
    else if (height > 195) heightRate = "+++";
    else if (height > 190) heightRate = "++";
    else if (height > 185) heightRate = "+";

    if (heightRate) result.push({ rate: heightRate, description: "HEI" });
  }

  // --- Positional versatility (DOUBLE / TRIPLE POS) ---
  if (typeof getOVRsOfPlayer === "function") {
    const ovrData = getOVRsOfPlayer(player);

    if (ovrData.length > 1) {
      const bestSecondary = ovrData[1].diff; // difference vs player.overall
      let doubleRate = "";

      if (bestSecondary >= 5) doubleRate = "+++";
      else if (bestSecondary >= 2) doubleRate = "++";
      else if (bestSecondary >= -1) doubleRate = "+";
      else doubleRate = "-"; // < -1 -> still show - DOUBLE POS

      result.push({
        rate: doubleRate,
        description: "2nd POS",
      });
    }

    if (ovrData.length > 2) {
      const secondBest = ovrData[2].diff;
      let tripleRate = "";

      if (secondBest >= 2) tripleRate = "+++";
      else if (secondBest >= -1) tripleRate = "++";
      else if (secondBest >= -4) tripleRate = "+";

      if (tripleRate)
        result.push({
          rate: tripleRate,
          description: "3rd POS",
        });
    }
  }

  // --- Sort from best to worst ---
  const rateOrder = ["+++", "++", "+", "-", "--", "---"];
  result.sort((a, b) => rateOrder.indexOf(a.rate) - rateOrder.indexOf(b.rate));

  return result;
}

export const getPlayerPricing = (player, pricings, yearValuations) => {
  if (player.retirementYears) {
    const yearValue = yearValuations.find((y) => y.overall === player.overall);
    if (yearValue == null) return null;
    return Number((yearValue.price * player.retirementYears).toFixed(1));
  }

  return pricings
    .filter((p) => p.overall === player.overall && p.age === player.age && p.position === player.positions[0])
    .map((p) => p.price)
    .pop();
};
